var map = {
	"./aladdin.gif": 878,
	"./aladdin2.gif": 3076,
	"./aladdin_snes_castle.png": 8122,
	"./aladdin_snes_gameover.gif": 2781,
	"./aladdin_snes_rugrun.gif": 9580,
	"./boardsofcanada.gif": 3723,
	"./cat.gif": 1275,
	"./darkforces.gif": 9157,
	"./darkforces2.gif": 1461,
	"./darkforces3.gif": 3228,
	"./dontcopy1.gif": 9624,
	"./dontcopy2.gif": 9711,
	"./dontcopy3.gif": 4838,
	"./dontcopy4.gif": 7749,
	"./dontcopy5.gif": 9084,
	"./fight.gif": 5569,
	"./game.gif": 8175,
	"./giphy.gif": 3442,
	"./goldenboy-fake-keyboard.gif": 8056,
	"./goldenboy-toilet.gif": 9166,
	"./gutsygibbon.jpg": 439,
	"./hackers.gif": 5238,
	"./hackers_cyberdelia.gif": 4445,
	"./hackers_foundpool.gif": 513,
	"./hackers_garbage.gif": 3254,
	"./hacktheplanet.gif": 4609,
	"./inside_your_computer.jpg": 4708,
	"./island_sunrise.gif": 5738,
	"./knoppix.jpg": 7281,
	"./lunedi_cinema_closing.gif": 3124,
	"./lunedi_cinema_starting.gif": 7791,
	"./mandrivaboot.jpg": 3698,
	"./mario.gif": 8587,
	"./maze_screensaver.gif": 1206,
	"./monkeyisland.gif": 4709,
	"./monkeyisland1.gif": 7354,
	"./motolabirinto.gif": 7824,
	"./oddparents.gif": 6667,
	"./oddparents2.gif": 755,
	"./oddparents3.gif": 7034,
	"./prince.gif": 3106,
	"./prince_of_persia_castle.png": 5793,
	"./prince_start.gif": 3403,
	"./princess.gif": 1512,
	"./rollerblade.gif": 6997,
	"./rollerblade1.gif": 8346,
	"./rollerblade2.gif": 2389,
	"./rollerblade3.gif": 7804,
	"./rollerblade4.gif": 8319,
	"./scumbar.gif": 2228,
	"./sega.gif": 1961,
	"./sneakers.gif": 1245,
	"./sonic.gif": 3639,
	"./space_jam.png": 1035,
	"./space_jam2.gif": 1758,
	"./space_jam3.gif": 4567,
	"./tenor.gif": 8541,
	"./toystory2.gif": 2368,
	"./tron_1.gif": 4364,
	"./tron_2.gif": 8611,
	"./tron_3.gif": 7898,
	"./tron_4.gif": 5873,
	"./tron_5.jpg": 7683,
	"./tron_6.gif": 1071,
	"./tron_uprising.jpg": 9545,
	"./tumblr1.jpg": 2683,
	"./tumblr2.gif": 9287,
	"./tumblr3.gif": 2478,
	"./tumblr4.gif": 4797,
	"./unix_video.gif": 4163,
	"./unix_video_2.gif": 5596,
	"./wargames.gif": 7938,
	"./wargames1.gif": 6455,
	"./whitewater.gif": 185,
	"./wicked_city.gif": 9078,
	"./yodastories.gif": 7099,
	"./yodastories1.gif": 3836,
	"./yodastories2.gif": 1603,
	"./yrose.png": 4792
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3072;